module.exports = __webpack_public_path__ + "ph.svg?009c7337b2d3df4097f4c9cb5b26d3c2";